import {
  GET_VISITS,
  GET_VISITS_SUCCESS,
  GET_VISITS_ERROR,
  SET_VISIT_ERROR,
  GET_REMARKS,
  GET_REMARKS_ERROR,
} from '../visits/VisitsConstants'

export const visitsReducerBlackListActions = [
  GET_VISITS,
  GET_VISITS_SUCCESS,
  GET_VISITS_ERROR,
  SET_VISIT_ERROR,
  GET_REMARKS,
  GET_REMARKS_ERROR,
]
